import React, { Component } from "react";
import { vrijwilligers, opdrachten, klanten } from "../../models/firestore";

import Button from "@material-ui/core/Button";
import Dialog from "@material-ui/core/Dialog";
import DialogTitle from "@material-ui/core/DialogTitle";
import DialogContent from "@material-ui/core/DialogContent";
import DialogActions from "@material-ui/core/DialogActions";
import TextField from "@material-ui/core/TextField";

import "../react-confirm-alert.css"; // Import css
import { ToastContainer, Zoom } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import * as jsPDF from "jspdf";
import autoTable from "jspdf-autotable";

import { withStyles } from "@material-ui/core/styles";
import * as alasql from "alasql";
import { observer } from "mobx-react";
import "react-table/react-table.css";

const styles = {
  container: {
    flex: 1,
    display: "flex",
    flexDirection: "column",
    position: "relative"
  },
  loader: {
    position: "absolute",
    left: 0,
    right: 0,
    top: 0,
    bottom: 0,
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "center"
  },
  header: {
    padding: 16,
    display: "flex",
    flexDirection: "row",
    justifyContent: "space-between",
    borderBottom: "1px solid #DDD"
  },
  content: {
    flex: 1,
    overflowY: "scroll"
  },
  add: {
    position: "absolute",
    top: 0,
    right: 0,
    height: 20
  }
};
const Overzichten = observer(
  class Overzichten extends Component {
    constructor(props) {
      super(props);
      this.state = {
        disabled: false,
        displayNaam: "",
        rollen: "",
        showall: false,
        showritten: false,
        prevQuery: undefined,
        currentFilter: "",
        datumPopupOpen: false,
        gekozenDatum: new Date().getFullYear() + "-01-01"
      };
    }
    componentDidMount() {
      // const editable =
      //   this.props.gebruikersrollen.search("admin") > -1 ||
      //   this.props.gebruikersrollen.search("kantoor") > -1;
      // this.setState({
      //   disabled: !editable
      // });
      //opdrachten.query = ref => ref.orderBy('timestamp');
      //opdrachten.query = ref => ref.where("typeopdracht", "==", "Chauffeur");
      //this.setState({ showstartoverzicht: true });
      this.setState({ showall: true });
      // console.log(autoTable); // suppress no unused-vars

      // opdrachten.query = ref =>
      //   ref
      //     // .where('datumuitvoering', '==', Date.now() //+ 7 * 24 * 60 * 60 * 1000)
      //     //.orderBy('timestamp', 'desc')
      //     .orderBy('uitvoeringsdatumtimestamp')
      //     .endAt(Date.now() + 7 * 24 * 60 * 60 * 1000)
      //     .limit(20);
      //.orderBy("timestamp");
      //to reset query: opdrachten.query = undefined
    }

    componentDidUpdate(prevProps, prevState) {
      // vrijwilligers.query = ref => ref.orderBy("geboortedatum");
      vrijwilligers.query = ref => ref.orderBy("gebsort");
      // opdrachten.query = ref2 =>
      //   ref2.where("datumopdracht", "in", ["2022"]).orderBy("achternaam");
      // Converteer gekozen datum naar timestamp
      const datumTimestamp = new Date(this.state.gekozenDatum).getTime();
      
      opdrachten.query = ref2 =>
        ref2
          .where("uitvoeringsdatumtimestamp", ">=", datumTimestamp)
          .orderBy("uitvoeringsdatumtimestamp")
          .orderBy("achternaam");
      klanten.query = ref3 => ref3.orderBy("achternaam");
      //  console.log(vrijwilligers);
    }

    VrijwilligersGebdatumEnOpmerking = (vw, datum) => {
      //var doc = new jsPDF();
      // const doc = new jsPDF();
      // doc.text('Hello landscape world!', 20, 20);
      // var string = doc.output('datauristring');
      // document.getElementById('output').src = string;

      var columns = [
        { title: "Voornaam", dataKey: "voornaam" },
        { title: "Achternaam", dataKey: "achternaamkort" },
        { title: "Geboortedatum", dataKey: "geboortedatum" },
        { title: "Opmerking", dataKey: "opmerking" }
      ];
      var rows = vw;

      // Only pt supported (not mm or in)
      var doc = new jsPDF("l", "pt");
      doc.autoTable(columns, rows, {
        styles: { fillColor: [219, 228, 240] },
        columnStyles: {
          //voornaam: { fillColor: 255 }
        },
        margin: { top: 40 },
        addPageContent: function(data) {
          doc.text("Vrijwilligers per " + datum, 30, 20);
        }
      });
      var string = doc.output("datauristring");
      document.getElementById("output").src = string;
      //doc.save("vrijwilligers.pdf");
    };

    Vrijwilligers = (vw, datum) => {
      //var doc = new jsPDF();
      // const doc = new jsPDF();
      // doc.text('Hello landscape world!', 20, 20);
      // var string = doc.output('datauristring');
      // document.getElementById('output').src = string;

      var columns = [
        { title: "Voornaam", dataKey: "voornaam" },
        { title: "Achternaam", dataKey: "achternaam" },
        { title: "Adres", dataKey: "adres" },
        { title: "Postcode", dataKey: "postcode" },
        { title: "Woonplaats", dataKey: "woonplaats" },
        { title: "Telefoon", dataKey: "telefoon" },
        { title: "Beschikbaar voor ", dataKey: "beschikbaarvoor" }
      ];
      var rows = vw;

      // Only pt supported (not mm or in)
      var doc = new jsPDF("l", "pt");
      doc.autoTable(columns, rows, {
        styles: { fillColor: [219, 228, 240] },
        columnStyles: {
          //voornaam: { fillColor: 255 }
        },
        margin: { top: 40 },
        addPageContent: function(data) {
          doc.text("Vrijwilligers per " + datum, 30, 20);
        }
      });
      var string = doc.output("datauristring");
      document.getElementById("output").src = string;
      //doc.save("vrijwilligers.pdf");
    };

    formatBeschikbaarheid = (beschikbaarheid) => {
      if (!beschikbaarheid) {
        return "-";
      }

      const dagen = ["", "Ma", "Di", "Wo", "Do", "Vr", "Za", "Zo"];
      const dagdelen = ["morgen", "middag", "avond"];
      const dagdeelLabels = { morgen: "M", middag: "Mi", avond: "A" };
      
      let beschikbaarheidTekst = [];
      
      dagdelen.forEach(dagdeel => {
        if (beschikbaarheid[dagdeel]) {
          const beschikbareDagen = [];
          for (let i = 1; i <= 7; i++) {
            if (beschikbaarheid[dagdeel][i] === true) {
              beschikbareDagen.push(dagen[i]);
            }
          }
          if (beschikbareDagen.length > 0) {
            beschikbaarheidTekst.push(
              `${dagdeelLabels[dagdeel]}: ${beschikbareDagen.join(", ")}`
            );
          }
        }
      });

      return beschikbaarheidTekst.length > 0 
        ? beschikbaarheidTekst.join(" | ") 
        : "-";
    };

    Chauffeurs = (datum) => {
      const { docs } = vrijwilligers;
      
      // Filter alleen vrijwilligers met Chauffeur: true en maak de data
      const chauffeursMetBeschikbaarheid = docs
        .filter(vrijwilliger => vrijwilliger.data.Chauffeur === true)
        .map(function(vrijwilliger) {
          let beschikbaarvoor = "";
          if (vrijwilliger.data.Telefoondienst) {
            beschikbaarvoor += " Tel";
          }
          if (vrijwilliger.data.Chauffeur) {
            beschikbaarvoor += " Chau";
          }
          if (vrijwilliger.data.ChauffeurInstellingen) {
            beschikbaarvoor += " Chauinst";
          }
          if (vrijwilliger.data.Boodschap) {
            beschikbaarvoor += " Bood";
          }
          if (vrijwilliger.data.Electra) {
            beschikbaarvoor += " Elec";
          }
          if (vrijwilliger.data.Tuin) {
            beschikbaarvoor += " Tuin";
          }
          if (vrijwilliger.data.Techniek) {
            beschikbaarvoor += " Tech";
          }
          if (vrijwilliger.data.Timmeren) {
            beschikbaarvoor += " Tim";
          }
          if (vrijwilliger.data.Wandelen) {
            beschikbaarvoor += " Wand";
          }
          if (vrijwilliger.data.Algemeneklusjes) {
            beschikbaarvoor += " Alg kl";
          }
          if (vrijwilliger.data.KlussenInstellingen) {
            beschikbaarvoor += " Klus inst";
          }

          const beschikbaarheidTekst = vrijwilliger.data.beschikbaarheid
            ? this.formatBeschikbaarheid(vrijwilliger.data.beschikbaarheid)
            : "-";

          const beschikbaarheidsInfo = vrijwilliger.data.beschikbaarheidsInfo
            ? vrijwilliger.data.beschikbaarheidsInfo
            : "-";

          return {
            voornaam: vrijwilliger.data.voornaam,
            achternaam: vrijwilliger.data.tussenvoegsel
              ? vrijwilliger.data.tussenvoegsel +
                " " +
                vrijwilliger.data.achternaam
              : vrijwilliger.data.achternaam,
            adres: vrijwilliger.data.adres,
            postcode: vrijwilliger.data.postcode,
            woonplaats: vrijwilliger.data.woonplaats,
            telefoon: vrijwilliger.data.telefoon,
            beschikbaarvoor: beschikbaarvoor,
            beschikbaarheid: beschikbaarheidTekst,
            memo: beschikbaarheidsInfo
          };
        }, this);

      var columns = [
        { title: "Voornaam", dataKey: "voornaam" },
        { title: "Achternaam", dataKey: "achternaam" },
        { title: "Adres", dataKey: "adres" },
        { title: "Postcode", dataKey: "postcode" },
        { title: "Woonplaats", dataKey: "woonplaats" },
        { title: "Telefoon", dataKey: "telefoon" },
        { title: "Beschikbaarheid", dataKey: "beschikbaarheid" },
        { title: "Memo", dataKey: "memo" }
      ];
      var rows = chauffeursMetBeschikbaarheid;

      // Only pt supported (not mm or in)
      var doc = new jsPDF("l", "pt");
      doc.autoTable(columns, rows, {
        styles: { fillColor: [219, 228, 240] },
        columnStyles: {
          memo: { cellWidth: 150 }
        },
        margin: { top: 40 },
        addPageContent: function(data) {
          doc.text("Chauffeurs per " + datum, 30, 20);
        }
      });
      var string = doc.output("datauristring");
      document.getElementById("output").src = string;
    };

    Huisnummer = (huisnummers, aantalhuisnummers) => {
      let huisnummersArr = [];

      huisnummersArr = alasql(
        "Select distinct huisnummer as huisnummer, Count(huisnummer) as aantal  from ? GROUP BY huisnummer order by COUNT(huisnummer) desc",
        [huisnummers]
      );
      var columns = [
        { title: "Huisnummer", dataKey: "huisnummer" },
        { title: "Aantal", dataKey: "aantal" }
      ];
      var rows = huisnummersArr;

      var doc = new jsPDF("l", "pt");
      doc.autoTable(columns, rows, {
        styles: { fillColor: [219, 228, 240] },
        columnStyles: {
          //voornaam: { fillColor: 255 }
        },
        margin: { top: 40 },
        addPageContent: function(data) {
          doc.text("Unieke huisnummers ", 30, 20);
        }
      });
      var string = doc.output("datauristring");
      document.getElementById("output").src = string;
    };

    Aantallen = (aant, datum, aantalopdrachten) => {
      // Even aant hanmatig omzetten
      let aantallen = [];
      let aantallenpervrijwilliger = [];
      let aantallenperklant = [];

      //  aantallen.push({typeopdracht: 'Chauffeur' , aantal: 5})
      //  aantallen.push({typeopdracht: 'Chauffeurinstellingen' , aantal: 25})
      //  aantallen.push({typeopdracht: 'Tuin' , aantal: 5})

      aantallen = alasql(
        "Select distinct typeopdracht as typeopdracht, Count(typeopdracht) as aantal  from ? GROUP BY typeopdracht order by COUNT(typeopdracht) desc",
        [aant]
      );

      aantallenpervrijwilliger = alasql(
        `Select distinct vrijwilliger as vrijwilliger, Count(vrijwilliger) as aantal , Round((Count (vrijwilliger) / ${aantalopdrachten})*100) as percentage from ? WHERE vrijwilliger <> '' GROUP BY vrijwilliger  order by COUNT(vrijwilliger) desc`,
        [aant]
      );

      aantallenperklant = alasql(
        `Select distinct achternaam as achternaam, Count(achternaam) as aantal ,Round((Count (achternaam) / ${aantalopdrachten})*100) as percentage from ? WHERE vrijwilliger <> '' GROUP BY achternaam order by COUNT(achternaam) desc`,
        [aant]
      );

      var columns = [
        { title: "Type opdracht", dataKey: "typeopdracht" },
        { title: "Aantal", dataKey: "aantal" }
      ];
      var columnsvrijwilliger = [
        { title: "Vrijwilliger", dataKey: "vrijwilliger" },
        { title: "Aantal", dataKey: "aantal" },
        { title: "Percentage", dataKey: "percentage" }
      ];
      var columnsaantalklanten = [
        { title: "Klant", dataKey: "achternaam" },
        { title: "Aantal", dataKey: "aantal" },
        { title: "Percentage", dataKey: "percentage" }
      ];

      var rowsopdrachten = aantallen;
      var rowsvrijwilligers = aantallenpervrijwilliger;
      var rowsaantalklanten = aantallenperklant;

      //   rowsopdrachten.sort(function(a,b) {
      //     return a[1] - b[1];
      // });
      // rowsvrijwilligers.sort(compareSecondColumn);
      // console.log("Hallo", aantallenperklant);

      // Only pt supported (not mm or in)
      var doc = new jsPDF("p", "pt");

      doc.setFont("helvetica");
      doc.setFontStyle("bold");
      doc.text("Datum overzicht: " + datum, 20, 20);

      doc.setFont("helvetica");
      doc.setFontStyle("normal");
      doc.text(
        "Totaal aantal opdrachten " + aantalopdrachten + " sinds " + this.formatDatumVoorWeergave(this.state.gekozenDatum),
        20,
        50
      );

      doc.autoTable(columns, rowsopdrachten, {
        theme: "grid",
        // styles: { fillColor: [0, 102, 255] },
        columnStyles: {
          //voornaam: { fillColor: 255 }
        },
        margin: { top: 100 },
        addPageContent: function(data) {
          doc.setFont("helvetica");
          doc.setFontStyle("bold");
          doc.text("Uitgesplitst per typeopdracht ", 20, 80);
        }
      });

      doc.addPage("p");
      doc.autoTable(columnsvrijwilliger, rowsvrijwilligers, {
        theme: "grid",
        // styles: { fillColor: [0, 102, 255] },
        columnStyles: {
          //voornaam: { fillColor: 255 }
        },
        margin: { top: 100 },
        addPageContent: function(data) {
          doc.setFont("helvetica");
          doc.setFontStyle("bold");
          doc.text("Uitgesplitst per vrijwilliger ", 20, 50);
        }
      });
      doc.addPage("p");
      doc.autoTable(columnsaantalklanten, rowsaantalklanten, {
        theme: "grid",
        // styles: { fillColor: [0, 102, 255] },
        columnStyles: {
          //voornaam: { fillColor: 255 }
        },
        margin: { top: 100 },
        addPageContent: function(data) {
          doc.setFont("helvetica");
          doc.setFontStyle("bold");
          doc.text("Uitgesplitst per klant ", 20, 50);
        }
      });

      //doc.addHTML('Hallo',40,20)
      var string = doc.output("datauristring");
      document.getElementById("output").src = string;
      //doc.save("vrijwilligers.pdf");
    };

    handleDatumPopupOpen = () => {
      this.setState({ datumPopupOpen: true });
    };

    handleDatumPopupClose = () => {
      this.setState({ datumPopupOpen: false });
    };

    handleDatumChange = (event) => {
      const inputDatum = event.target.value;
      
      // Valideer of de datum geldig is
      const datumObject = new Date(inputDatum);
      if (isNaN(datumObject.getTime()) || inputDatum === '') {
        // Als datum ongeldig is, zet op 01-01 van huidige jaar
        const huidigeJaar = new Date().getFullYear();
        this.setState({ gekozenDatum: huidigeJaar + "-01-01" });
      } else {
        this.setState({ gekozenDatum: inputDatum });
      }
    };

    handleDatumBevestigen = () => {
      this.setState({ datumPopupOpen: false });
      // Forceer een re-render om de nieuwe datum te gebruiken
      this.forceUpdate();
    };

    formatDatumVoorWeergave = (datumString) => {
      const datum = new Date(datumString);
      if (isNaN(datum.getTime())) {
        return "01 Jan " + new Date().getFullYear();
      }
      
      const maanden = [
        "Jan", "Feb", "Mrt", "Apr", "Mei", "Jun",
        "Jul", "Aug", "Sep", "Okt", "Nov", "Dec"
      ];
      
      const dag = datum.getDate().toString().padStart(2, '0');
      const maand = maanden[datum.getMonth()];
      const jaar = datum.getFullYear();
      
      return `${dag} ${maand} ${jaar}`;
    };

    render() {
      const { docs } = vrijwilligers;
      const { _docs } = opdrachten;

      const { classes } = this.props;
      let vw = [];
      let aant = [];
      let aantalopdrachten = 0;
      let uniekehs = [];

      const dagmaandjaarFormat = startDate => {
        const sd = new Date(startDate);
        let maand = (sd.getMonth() + 1).toString();
        if (maand.length === 1) {
          maand = "0" + maand;
        }
        let dag = sd.getDate().toString();
        if (dag.length === 1) {
          dag = "0" + dag;
        }

        var returnDate = dag + "-" + maand + "-" + sd.getFullYear();

        return returnDate;
      };

      aantalopdrachten = _docs.length;

      //aantalhuisnummers = _hs.length;
      if (klanten) {
        uniekehs = klanten.docs.map(function(klant) {
          return {
            huisnummer: klant.data.huisnummer
          };
        });
      }

      aant = _docs.map(function(opd) {
        return {
          // voornaam: opd.data.voornaam,
          achternaam: opd.data.tussenvoegsel
            ? opd.data.tussenvoegsel +
              " " +
              opd.data.achternaam +
              "( " +
              opd.data.adres +
              " )"
            : opd.data.achternaam +
              " ( " +
              opd.data.adres +
              " )" +
              " " +
              opd.data.typeopdracht,
          typeopdracht: opd.data.typeopdracht,
          vrijwilliger: opd.data.vrijwilliger,
          opdrachtuitgevoerd: opd.data.opdrachtuitgevoerd,
          adres: opd.data.adres
        };
      });

      vw = docs.map(function(vrijwilliger) {
        let beschikbaarvoor = "";
        if (vrijwilliger.data.Telefoondienst) {
          beschikbaarvoor += " Tel";
        }
        if (vrijwilliger.data.Chauffeur) {
          beschikbaarvoor += " Chau";
        }
        if (vrijwilliger.data.ChauffeurInstellingen) {
          beschikbaarvoor += " Chauinst";
        }
        if (vrijwilliger.data.Boodschap) {
          beschikbaarvoor += " Bood";
        }
        if (vrijwilliger.data.Electra) {
          beschikbaarvoor += " Elec";
        }
        if (vrijwilliger.data.Tuin) {
          beschikbaarvoor += " Tuin";
        }
        if (vrijwilliger.data.Techniek) {
          beschikbaarvoor += " Tech";
        }
        if (vrijwilliger.data.Timmeren) {
          beschikbaarvoor += " Tim";
        }
        if (vrijwilliger.data.Wandelen) {
          beschikbaarvoor += " Wand";
        }
        if (vrijwilliger.data.Algemeneklusjes) {
          beschikbaarvoor += " Alg kl";
        }
        if (vrijwilliger.data.KlussenInstellingen) {
          beschikbaarvoor += " Klus inst";
        }

        return {
          voornaam: vrijwilliger.data.voornaam,
          achternaam: vrijwilliger.data.tussenvoegsel
            ? vrijwilliger.data.tussenvoegsel +
              " " +
              vrijwilliger.data.achternaam
            : vrijwilliger.data.achternaam,
          adres: vrijwilliger.data.adres,
          postcode: vrijwilliger.data.postcode,
          woonplaats: vrijwilliger.data.woonplaats,
          telefoon: vrijwilliger.data.telefoon,
          beschikbaarvoor: beschikbaarvoor,
          geboortedatum:
            new Date(vrijwilliger.data.geboortedatum).toLocaleDateString(
              "nl-NL"
            ) || "nb",
          opmerking: vrijwilliger.data.beschikbaarheidsInfo || "-",
          achternaamkort: vrijwilliger.data.achternaam
            .toString()
            .substring(0, 2)
        };
      });

      return (
        <div>
          <div align="left" style={{ paddingRight: 20, paddingBottom: 15 }}>
            <Button
              variant="contained"
              size="medium"
              color="secondary"
              className={classes.button}
              disabled={
                this.props.gebruikersrollen.search("overzichten") === -1
              }
              onClick={this.handleDatumPopupOpen}
              style={{ marginTop: 0, marginRight: 20, marginLeft: 20 }}
            >
              Datum instellen
            </Button>
            <Button
              //variant="fab"
              variant="contained"
              size="medium"
              color="primary"
              //aria-label="add"
              className={classes.button}
              disabled={
                this.props.gebruikersrollen.search("overzichten") === -1
              }
              onClick={() =>
                this.Vrijwilligers(vw, dagmaandjaarFormat(Date.now()))
              }
              style={{ marginTop: 0, marginRight: 20, marginLeft: 20 }}
            >
              Vrijwilligers
            </Button>
            <Button
              //variant="fab"
              variant="contained"
              size="medium"
              color="primary"
              //aria-label="add"
              className={classes.button}
              disabled={
                this.props.gebruikersrollen.search("overzichten") === -1
              }
              onClick={() =>
                this.VrijwilligersGebdatumEnOpmerking(
                  vw,
                  dagmaandjaarFormat(Date.now())
                )
              }
              style={{ marginTop: 0, marginRight: 20, marginLeft: 20 }}
            >
              Vrijwilligers met gebdatum en opmerking
            </Button>
            <Button
              //variant="fab"
              variant="contained"
              size="medium"
              color="primary"
              //aria-label="add"
              className={classes.button}
              disabled={
                this.props.gebruikersrollen.search("overzichten") === -1
              }
              onClick={() =>
                this.Aantallen(
                  aant,
                  dagmaandjaarFormat(Date.now()),
                  aantalopdrachten
                )
              }
              style={{ marginTop: 0, marginRight: 20, marginLeft: 20 }}
            >
              Aantallen
            </Button>
            <Button
              //variant="fab"
              variant="contained"
              size="medium"
              color="primary"
              //aria-label="add"
              className={classes.button}
              disabled={
                this.props.gebruikersrollen.search("overzichten") === -1
              }
              onClick={() => this.Huisnummer(uniekehs)}
              style={{ marginTop: 0, marginRight: 20, marginLeft: 20 }}
            >
              Huisnummers
            </Button>
            <Button
              //variant="fab"
              variant="contained"
              size="medium"
              color="primary"
              //aria-label="add"
              className={classes.button}
              disabled={
                this.props.gebruikersrollen.search("overzichten") === -1
              }
              onClick={() =>
                this.Chauffeurs(dagmaandjaarFormat(Date.now()))
              }
              style={{ marginTop: 0, marginRight: 20, marginLeft: 20 }}
            >
              Chauffeurs
            </Button>
          </div>
          <div height="100%" width="100%" align="center">
            <iframe title="PDFoutput" id="output" width="850" height="850" />
          </div>

          <ToastContainer
            position="top-center"
            transition={Zoom}
            autoClose={2000}
            hideProgressBar={false}
            newestOnTop={false}
            closeOnClick={false}
            rtl={false}
            pauseOnVisibilityChange
            draggable
            pauseOnHover
            closeButton={false}
          />

          {/* Datum Popup Dialog */}
          <Dialog
            open={this.state.datumPopupOpen}
            onClose={this.handleDatumPopupClose}
            aria-labelledby="datum-dialog-title"
          >
            <DialogTitle id="datum-dialog-title">
              Datum instellen voor overzichten
            </DialogTitle>
            <DialogContent>
              <TextField
                autoFocus
                margin="dense"
                id="datum"
                label="Datum vanaf"
                type="date"
                value={this.state.gekozenDatum}
                onChange={this.handleDatumChange}
                fullWidth
                InputLabelProps={{
                  shrink: true,
                }}
              />
              <p style={{ marginTop: 16, fontSize: 14, color: '#666' }}>
                Opdrachten vanaf deze datum worden meegenomen in de overzichten.
              </p>
            </DialogContent>
            <DialogActions>
              <Button onClick={this.handleDatumPopupClose} color="primary">
                Annuleren
              </Button>
              <Button onClick={this.handleDatumBevestigen} color="primary" variant="contained">
                Bevestigen
              </Button>
            </DialogActions>
          </Dialog>
        </div>
      );
    }
  }
);

export default withStyles(styles)(Overzichten);



// WEBPACK FOOTER //
// ./src/components/Overzichten/Overzichten.jsx